
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 50 50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24 49.98a24.864 24.864 0 01-10.627-2.842L17.38 40.2a16.902 16.902 0 006.62 1.77v8.01zM3.864 38.358a25.131 25.131 0 007.778 7.778l4.006-6.938a17.092 17.092 0 01-4.847-4.846l-6.937 4.006zM2.862 36.626A24.864 24.864 0 01.02 26h8.009c.137 2.37.76 4.61 1.77 6.621l-6.937 4.005zM15.648 10.801a17.092 17.092 0 00-4.847 4.847l-6.937-4.006a25.132 25.132 0 017.778-7.778l4.006 6.937zM13.373 2.862A24.865 24.865 0 0124 .02v8.01c-2.37.137-4.61.76-6.621 1.77l-4.006-6.937zM8.029 24c.137-2.37.76-4.61 1.77-6.621l-6.937-4.006A24.864 24.864 0 00.02 24h8.009z","fill":"#1FD552"}}),_c('path',{attrs:{"opacity":".7","d":"M36.626 47.138A24.864 24.864 0 0126 49.98v-8.01c2.37-.136 4.61-.76 6.621-1.77l4.005 6.938z","fill":"#1FD552"}}),_c('path',{attrs:{"opacity":".4","d":"M34.352 39.199a17.093 17.093 0 004.846-4.847l6.938 4.006a25.132 25.132 0 01-7.78 7.778l-4.004-6.938z","fill":"#1FD552"}}),_c('path',{attrs:{"opacity":".2","d":"M41.97 26c-.137 2.37-.76 4.61-1.77 6.62l6.937 4.006A24.865 24.865 0 0049.98 26h-8.01z","fill":"#1FD552"}})])
          )
        }
      }
    